export const auctionFragment = `
  fragment auction on Auction {
    id
    title
    type
  }
`;
